var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"first-component",staticStyle:{"background-image":"url('/img/first-component.png')"}},[_c('AnimatingTextComponent',{attrs:{"text":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }